import { useEffect, useState } from 'react';
import { Offcanvas, Form, Button } from 'react-bootstrap';
import Select from 'react-select';
import Loading from '../../Common/Loading';
import FilePageService from '../../API/FilePage/FilePageService';
import { useTranslation } from 'react-i18next';

const EditGuaranteeBasis = ({ show, onHide, search, sort, currentPage, editGuaranteeBasisId, GuaranteeBasisList }) => {
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState(false);
    const [flashMessage, setFlashMessage] = useState({ type: "", message: "" });
    const [riskTypeList, setRiskTypeList] = useState([]);
    const [selectRiskType, setSelectRiskType] = useState([]);
    const [showGuaranteeBasisList, setShowGuaranteeBasisList] = useState([]);
    const [amountFranchise, setAmountFranchise] = useState(null);

    const handleFormCloseEdit = () => {
        onHide();
        setSelectRiskType([]);
        setShowGuaranteeBasisList([]);
        setAmountFranchise(null);
    };

    useEffect(() => {
        if (show) {
            RiskTypeList();
        }
    }, [show]);

    useEffect(() => {
        if (editGuaranteeBasisId && riskTypeList && Object.keys(riskTypeList).length > 0) {
            ShowGuaranteeBasis(editGuaranteeBasisId);
        }
    }, [editGuaranteeBasisId, riskTypeList]);

    useEffect(() => {
        if (flashMessage.message) {
            const timer = setTimeout(() => {
                setFlashMessage({ type: "", message: "" });
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [flashMessage]);

    const RiskTypeList = async () => {
        setIsLoading(true);
        try {
            const response = await FilePageService.risk_types_list();

            if (response.data.status) {
                setIsLoading(false);
                setRiskTypeList(response.data.risk_types);
            }
        } catch (error) {
            setIsLoading(false);
            console.log(error);
        }
    };

    const ShowGuaranteeBasis = async (id) => {
        setIsLoading(true);
        try {
            const response = await FilePageService.show_guarantee_basis(id);

            if (response.data.status) {
                const qData = response.data.GuaranteeBasis;
                const selectedRiskType = riskTypeOptions.find(
                    (option) => option.value.toString() === qData.risk_type?.toString()
                );

                setShowGuaranteeBasisList(response.data.GuaranteeBasis);
                setAmountFranchise(response.data.GuaranteeBasis.amount_franchise);
                setSelectRiskType(selectedRiskType);
                setIsLoading(false);
            }
        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    };

    const UpdateGuaranteeBasis = async (e) => {
        e.preventDefault();

        if (
            e.target.elements.nameLabel.value == "" ||
            selectRiskType?.value == ""
        ) {
            setFlashMessage({
                type: "error",
                message: t("requriedErrorMessageLabel"),
            });
            return;
        }

        try {
            var useData = {
                name: e.target.elements.nameLabel.value ?? "",
                risk_type: selectRiskType?.value ?? "",
                conditions: e.target.elements.conditions.value ?? "",
                ...(amountFranchise && { amount_franchise: amountFranchise }),
                description: e.target.elements.description.value ?? "",
            };

            const response = await FilePageService.edit_guarantee_basis(
                editGuaranteeBasisId,
                useData
            );

            if (response.data.status) {
                handleFormCloseEdit();
                GuaranteeBasisList(search, sort, currentPage, "", "");
            } else {
                setFlashMessage({
                    type: "error",
                    message: response.data.message || t("somethingWentWrong"),
                });
            }
        } catch (error) {
            setFlashMessage({
                type: "error",
                message: error.response.data.message || t("somethingWentWrong"),
            });
        }
    };

    const handleChange = (e) => {
        let value = e.target.value;

        if (value === "") {
            setAmountFranchise("");
            return;
        }

        if (!/^\d*\.?\d{0,2}$/.test(value)) {
            return;
        }

        if (value.length > 1 && value[0] === "0" && value[1] !== ".") {
            value = value.replace(/^0+/, "");
        }

        setAmountFranchise(value);
    };

    const riskTypeOptions = Object.entries(riskTypeList).map(([key, label]) => ({
        value: key,
        label: label,
    }));

    return (
        <Offcanvas
            className="account-request-pannel"
            placement="end"
            show={show}
            onHide={handleFormCloseEdit}
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Modifier la base de garantie</Offcanvas.Title>
            </Offcanvas.Header>

            {isLoading ? (
                <Loading />
            ) : (
                <Offcanvas.Body>
                    <Form
                        onSubmit={UpdateGuaranteeBasis}
                    >
                        {flashMessage.message && (
                            <div
                                className={`alert ${flashMessage.type === "success"
                                    ? "alert-success"
                                    : "alert-danger"
                                    } text-center`}
                                role="alert"
                            >
                                {flashMessage.message}
                            </div>
                        )}

                        <Form.Group controlId="nameLabel">
                            <Form.Label>
                                {t("nameLabel")} <span>*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                placeholder={t("nameLabel")}
                                defaultValue={showGuaranteeBasisList?.name}
                                name="nameLabel"
                                maxLength={25}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>
                                Type de risque <span>*</span>
                            </Form.Label>
                            <Select
                                options={riskTypeOptions}
                                value={riskTypeOptions.find(
                                    (option) => option.value == selectRiskType?.value
                                )}
                                onChange={(selectedOption) => setSelectRiskType(selectedOption)}
                                styles={{
                                    container: (provided) => ({ ...provided, width: "100%" }),
                                    menu: (provided) => ({ ...provided, width: "100%" }),
                                }}
                                placeholder={"Sélectionnez le type de risque"}
                                isSearchable={true}
                                noOptionsMessage={() => t("NorecordsfoundLabel")}
                            />
                        </Form.Group>

                        <Form.Group controlId="conditions">
                            <Form.Label>{t("Conditions")}</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder={t("Conditions")}
                                defaultValue={showGuaranteeBasisList?.conditions}
                                name="conditions"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Montant de la franchise</Form.Label>
                            <Form.Control
                                type="number"
                                name="amount_franchise"
                                value={amountFranchise}
                                onChange={handleChange}
                                placeholder="Montant de la franchise"
                                min={0}
                                step="any"
                                onWheel={(e) => e.target.blur()}
                            />
                        </Form.Group>

                        <Form.Group controlId="description">
                            <Form.Label>{t("Description")}</Form.Label>
                            <Form.Control
                                as="textarea"
                                placeholder={t("Description")}
                                defaultValue={showGuaranteeBasisList?.description}
                                name="description"
                                rows={8}
                                className="w-100"
                            />
                        </Form.Group>

                        <div className="canvas-footer text-end mt-3">
                            <Button variant="primary" type="submit">
                                {t("submitButton")}
                            </Button>
                        </div>
                    </Form>
                </Offcanvas.Body>
            )}
        </Offcanvas>
    );
};

export default EditGuaranteeBasis;